import React from 'react';
import PropTypes from 'prop-types';

export default function Button({ text }) {
  return <button>{text}</button>;
}

//----------------------------------- PROPTYPES --------------------------------------------------//
Button.propTypes = {
  text: PropTypes.string,
};

//------------------------------------------------------------------------------------------------//
